<!--Only for JPPC user-->
<template>
  <div>
    <div v-if="!isRegistered">
      <p class="desc">下記のご案内をよくお読みになり、本人確認にお進みください。</p>
      <div class="content_wrap">
        <div class="caution_wrap">
          <h3>ご対応の流れ</h3>
          <ul>
            <li>
              <h4>1. ご本人様確認書類をご準備ください。</h4>
              <p>
                氏名、生年月日、住所が「印字」された、A～Dいずれか1点<br />
                &nbsp;A. 運転免許証<br />
                &nbsp;B. マイナンバーカード<br />
                &nbsp;C. 住民票(取得から3ヶ月以内のもの)<br />
                &nbsp;D. 保険証
              </p>
            </li>
            <li>
              <h4>2．以下に該当する場合は、同意書文書をご準備ください。</h4>
              <p>
                &nbsp;・未成年の方で、保護者の口座をお振込み先に指定される場合<br />
                &nbsp;・
                クリエイターの活動にあたり事務所等の法人に所属又は法人を運営する場合に、法人名義の口座をお振込み先に指定される場合<br />
                本ページ下段にございます、同意文書をダウンロードして印刷し、署名捺印をお願いいたします。
              </p>
            </li>
            <li>
              <h4>3. 本人確認情報登録ページに進み、必要情報を入力してください。</h4>
            </li>
            <li>
              <h4>4. ご本人様確認書類をアップロードしてください。</h4>
              <p>
                同意書文書の提出が必要な方は、同意書文書も合わせてアップロードしてください。<br />
                &nbsp;※顔写真や番号が、鮮明に表示されているかご確認ください。<br />
                &nbsp;※スキャンしたファイル、もしくはスマートフォンなどのカメラで撮影した画像でご申請が可能です。
              </p>
            </li>
            <li>
              <h4>5. 弊社でアップロードいただいた情報の確認が完了後、出金申請にお進みいただけます。</h4>
              <p>&nbsp;※本人確認の結果はメールでお知らせいたします。</p>
            </li>
          </ul>
        </div>
        <div class="caution_wrap">
          <h3>本対応における注意事項</h3>
          <ul>
            <li>
              <h4>【注意事項1】</h4>
              <p>
                住所が「印字」ではなく、「手書き」された書類の場合は<br />
                以下書類につきましても追加でアップロードをお願いいたします。<br />
                ・ 公共料金（電気・水道・ガス代）の領収書（3ヶ月以内のもの）<br />
                例）「保険証」+「電気代　領収書（3ヶ月以内のもの）」
              </p>
            </li>
            <li>
              <h4>【注意事項2】</h4>
              <p>住民票の場合は【マイナンバー（個人番号）のないもの】をアップロードしてください。</p>
            </li>
            <li>
              <h4>【注意事項3】</h4>
              <p>
                マイナンバーカードの場合は【表面のみ】をアップロードしてください。<br />
                ※マイナンバー（個人番号）の記載がある<br />
                &nbsp;「住民票」「マイナンバーカードの裏面」「マイナンバー通知カード」は<br />
                &nbsp;本人確認書類として受領できませんので、予めご了承ください
              </p>
            </li>
          </ul>
        </div>
        <div class="caution_wrap">
          <h3>同意書文書をダウンロード</h3>
          <ul>
            <li>
              以下に該当する場合は、以下の同意書文書をダウンロードして印刷し、署名捺印をお願いいたします。<br />
              次の本人確認情報登録画面にてご本人様確認書類と一緒にアップロードしてください。<br />
              &nbsp;・未成年の方で、保護者の口座をお振込み先に指定される場合<br />
              <a class="agreement_doc" href="/static/nj-teenager-agreement.pdf" download="未成年者/保護者口座利用.pdf"
                >同意書ダウンロード</a
              ><br />
              &nbsp;・クリエイターの活動にあたり事務所等の法人に所属又は法人を運営する場合に、法人名義の口座をお振込み先に指定される場合<br />
              <a class="agreement_doc" href="/static/nj-company-agreement.pdf" download="法人口座利用.pdf"
                >同意書ダウンロード</a
              >
            </li>
          </ul>
          <p class="last_caution">
            <a href="https://guide.nexon.com/ja/game/rp/guides/jp/pages/401" target="_blank">本人確認情報登録ガイド</a
            >を必ず事前にご確認の上、登録にお進みください。
          </p>
        </div>
        <div class="btn_wrap">
          <button class="btn01 next_btn" @click="handleGoToRegister">次へ</button>
        </div>
      </div>
    </div>
    <div v-else>
      <auth-view :registeredData="registeredData" :registeredFileList="registeredFileList"></auth-view>
    </div>
  </div>
</template>

<script>
import AuthView from '@/components/modules/auth/AuthView';

export default {
  name: 'AuthViewGuide',
  components: {
    AuthView,
  },
  props: {
    isRegistered: {
      type: Boolean,
      default: false,
    },
    registeredData: {
      type: Object,
      default: () => {},
    },
    registeredFileList: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleGoToRegister() {
      const { guide, ...restQuery } = this.$route.query;
      this.$router.push({ name: 'AuthRegister', query: { ...restQuery } });
      window.scrollTo({ top: 0 });
    },
  },
};
</script>

<style scoped>
.desc {
  color: #45475a;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
}
h3 {
  color: #111;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 15px;
}
.content_wrap {
  /*width: 960px;*/
  border: 1px solid #eee;
  background: #fff;
  padding: 30px;
}
.caution_wrap {
  margin-bottom: 30px;
}
.last_caution {
  text-align: center;
}
p,
li {
  color: #333;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  margin-bottom: 20px;
}
.btn_wrap {
  display: flex;
  justify-content: center;
}
.next_btn {
  width: 180px;
  height: 40px;
  font-size: 13px;
}
a {
  color: #137fe2;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-decoration-line: underline;
}
.agreement_doc {
  margin-left: 18px;
}
@media all and (max-width: 767px) {
  .desc {
    margin-left: 30px;
  }
  .content_wrap {
    padding: 30px 15px;
  }
  .next_btn {
    width: 100%;
  }
}

@media all and (max-width: 480px) {
  .desc {
    margin-left: 15px;
  }
}
</style>
